import * as types from './types'
import storage from '@/plugins/storage'
import globals from '@/plugins/globals.js'
export default {
  [types.RESET_LOGIN](state) {
    state.language = ''
    state.isLogout = true
    state.roles = null
    state.token = null
    state.username = null
    state.userProfile = null
    storage.session.clear()
    storage.local.clear()
    storage.local.setItem(types.SESSION_USER_TOKEN, JSON.stringify(state.userToken))
  },
  [types.SET_TOKEN](state, token) {
    state.token = token
    storage.local.setItem(types.SESSION_TOKEN_NAME, token)
  },
  [types.SET_USER_INFO](state, info) {
    state.userInfo = info
    state.language = info.language
  },
  [types.SET_ROLES](state, profile) {
    state.primaryRole = ''
    if (profile && profile.Roles && profile.Roles.length) {
      let roles = profile.Roles.map(r => r.Name)
      state.roles = roles
      storage.local.setItem(
        types.SESSION_ROLES_NAME,
        JSON.stringify(roles)
      )
      for (let role of roles) {
        if (role === 'InShopTech' || role === 'DiagCoord') {
          state.primaryRole = 'Tech'
          break
        } else if (role === 'MasterTech') {
          state.primaryRole = 'MasterTech'
          break
        } else if (role === 'Dispatch') {
          state.primaryRole = 'Dispatch'
          break
        }
      }
      if (state.primaryRole === '') {
        state.primaryRole = roles[0]
      }
    }
    storage.local.setItem(
      types.SESSION_PRIMARY_ROLE,
      JSON.stringify(state.primaryRole)
    )
    state.userProfile = null
    if (profile) {
      state.userProfile = {
        id: profile.Id || profile.UserId,
        location: profile.Location,
        timeZone: profile.TimeZone,
        firstName: profile.GivenName || profile.FirstName,
        lastName: profile.FamilyName || profile.LastName,
        userName: profile.Username,
        email: profile.Email,
        phone: '',
        isNew: true,
        isUK: profile.IsUK,
        contact: null,
        language: profile.Language
      }
      storage.local.setItem(
        types.SESSION_USER_PROFILE,
        JSON.stringify(state.userProfile)
      )
      globals.username = profile.Username
      globals.email = profile.Email
    }
  },
  [types.SET_LOCATION_KEY](state, data) {
    state.userProfile.location.key = data.sid
    storage.local.setItem(
      types.SESSION_USER_PROFILE,
      JSON.stringify(state.userProfile)
    )
  },
  [types.SET_BUSINESS_USERS](state, data) {
    state.businessUsers = []
    data.forEach(element => {
      if (element.id !== null) {
        state.businessUsers.push({
          value: element.id,
          name: `${element.firstName} ${element.lastName}`,
          email: element.email
        })
      }
    })
  },
  [types.SET_CONTACT](state, id) {
    for (let user of state.businessUsers) {
      if (user.id === id) {
        state.userProfile.id = id
        state.userProfile.firstName = user.firstName
        state.userProfile.lastName = user.lastName
        state.userProfile.email = user.email
        state.userProfile.phone = user.phone
        state.userProfile.isNew = false
        state.userProfile.contact = null
        storage.local.setItem(
          types.SESSION_USER_PROFILE,
          JSON.stringify(state.userProfile)
        )
        break
      }
    }
  },
  [types.UPDATE_CONTACT](state, data) {
    state.userProfile.firstName = data.firstName
    state.userProfile.lastName = data.lastName
    state.userProfile.email = data.email
    state.userProfile.phone = data.phone
    state.userProfile.isNew = false
    state.userProfile.contact = data.contact
    storage.local.setItem(
      types.SESSION_USER_PROFILE,
      JSON.stringify(state.userProfile)
    )
    state.userToken = {
      id: data.contact,
      token: data.email
    }
    storage.local.setItem(types.SESSION_USER_TOKEN, JSON.stringify(state.userToken))
  },
  [types.SET_LANGUAGE](state, language) {
    state.language = language
    storage.local.setItem(types.SESSION_LANGUAGE, language)
  },
  [types.SET_PASSTHROUGH](state, passthrough) {
    state.passthrough = passthrough
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js